export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const CREATE_CATEGORIES = 'CREATE_CATEGORIES';